function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 43.75h76.063L41.124 8.812 50 0l50 50-50 50-8.813-8.813L76.064 56.25H0v-12.5z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  transform: "matrix(-1 0 0 1 100 0)",
  d: "M0 0h100v100H0z"
})));

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgArrow;